export default __webpack_public_path__ + "static/media/WaPOR_wordmark-removebg.c3609478.png";